module.exports = __webpack_public_path__ + "static/Zoom-2c9b9c0ef04d7239e857214c2ff0f42a.jpg";